import { render, staticRenderFns } from "./ImageWebp.vue?vue&type=template&id=70d031fb&"
import script from "./ImageWebp.vue?vue&type=script&lang=js&"
export * from "./ImageWebp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports